<template>
    <div class="comment-content-wrapper">
        <loading :ifLoadingStart="ifLoginLoading"></loading>
        <template v-if="!ifLoginLoading">
            <div class="top-box" style="position: relative">
                <div class="left-content">
                    <p>评论及评分</p>
                    <p class="score" v-if="appSate.star">{{ appSate.star }}</p>
                    <p class="no-score" v-else>暂无评分</p>
                    <p class="summary">
                        <span>满分</span>
                        <strong>5.0</strong>
                        <span>，共</span>
                        <strong>{{ commentList.length || '0' }}</strong>
                        <span>条评论</span>
                    </p>
                </div>
                <ul class="center-content">
                    <li class="content-item" v-for="(item, index) in appSate.star_user" :key="index">
                        <div class="star-area">
                            <i v-for="val in 5 - index" :key="val" class="el-icon-star-on"></i>
                        </div>
                        <div class="progress-area">
                            <span class="progress" :style="{ width: `${item/allCommentPerson*100}%` }"></span>
                        </div>
                        <div class="user-area">{{item}}人</div>
                    </li>
                </ul>
                <div class="right-content">
                    <div v-if="!isLogin" class="not-login">
                        <p>
                            <span class="login" @click="login">登录</span>
                            <span>后，即可参与评论</span>
                        </p>
                        <div class="login-btn smart-button" @click="login">立即登录</div>
                    </div>
                    <!-- 自己有登录但没有评论时显示撰写按钮 -->
                    <div v-else-if="!myComment.isComment" class="comment smart-button" @click="onWriteComment">
                        <img src="../../images/common/edit.png" alt="">
                        <span>撰写评论</span>
                    </div>
                </div>
            </div>
            <div class="comment-header" v-if="commentList.length">
                <p>共<span class="comment-num">{{ commentList.length || '0' }}</span>条数据</p>
                <el-popover
                    popper-class="sort-popover"
                    placement="bottom"
                    width="97"
                    :visible-arrow="false"
                    v-model="visible"
                    trigger="click">
                    <ul>
                        <li
                            :class="['sort-item', {'active': defaultSortCondition === item.type}]"
                            v-for="item in commentSortConditionList"
                            :key="item.type"
                            @click="handleCommentSort(item.type)">
                            {{item.name}}
                        </li>
                    </ul>
                    <span slot="reference" class="new-comment">
                        {{ defaultSortCondition === 'comment' ? '最新评论' : '评分最高' }}
                        <img src="../../images/application_detail/hover-angle-up.png" alt="">
                    </span>
                </el-popover>
            </div>

            <div class="bottom-box" v-if="commentList.length">
                <ul class="msg-list">
                <li class="msg-item" v-for="(item, index) in commentList" :key="index">
                    <div class="msg-content">
                    <div class="left-box">
                        <img :src="item.user_logo.indexOf('?') === 0 ? defaultAvatar : item.user_logo" @click="goHomePage(item)">
                    </div>
                    <div :class="['center-box', {'show-replay': item.replyShow}]">
                        <div class="user-info">
                            <span @click="goHomePage(item)" class="nick_name">{{item.nick_name}}</span>
                            <template v-for="(badge, index) in badgeList">
                                <el-tooltip
                                    v-if="item.user_badges[index]"
                                    :key="index"
                                    :content="badge.text"
                                    effect="dark"
                                    placement="top">
                                    <img class="icon-medal" :src="badge.url" alt="">
                                </el-tooltip>
                            </template>
                            <span v-if="item.is_self" class="author">我自己</span>
                            <span v-else-if="item.is_author" class="author">作者</span>
                        </div>
                        <el-rate
                            class="star-rate"
                            v-model="item.star"
                            :disabled="true"
                            void-icon-class="el-icon-star-on"
                            disabled-void-color="#c4c6cc"
                            :colors="['#fe9c00', '#fe9c00', '#fe9c00']">
                        </el-rate>
                        <p class="comment" style="word-break: break-word;" v-html="filterXSS(item.content)"></p>
                        <!-- <div class="comment">
                            相当的Nice，对工作很有用，帮助我减轻了很多不必要的杂活儿，给作者赞一个！有了它，排查系统负载高的进程一目了然，赞！
                        </div> -->
                        <div class="center-footer">
                            <div class="interact">
                                <div :class="['agree', {'active': item.is_favor}]" @click="agreeComment(item.cmt_id, false)">
                                    <span class="like-img"></span>
                                    <span>赞</span>
                                    <span class="number">{{item.agree_cnt}}</span>
                                </div>
                                <div class="reply" @click="unFoldReplyList(item.cmt_id, false, 1)">
                                    <span class="reply-img"></span>
                                    <span v-if="item.replyShow && item.replyContent.length">收起回复</span>
                                    <template v-else>
                                        <span>回复</span>
                                        <span class="number">{{item.reply_cnt}}</span>
                                    </template>
                                </div>
                                <div
                                    v-if="myComment.data.user_logo !== '' && item.is_self"
                                    class="delete"
                                    @click="secondaryPopup('myComment')">
                                    <i class="el-icon-delete"></i>
                                    <span>删除</span>
                                </div>
                            </div>
                            <span class="time">{{item.create_time}}</span>
                        </div>
                        <transition name="show">
                            <ul class="reply-list" v-show="item.replyShow">
                                <li class="myreply">
                                    <div class="textarea-wrapper">
                                        <textarea class="msg" :placeholder="`回复${item.nick_name}`" name="msg" rows="8" cols="80" v-model="item.replyContent" maxlength="200"></textarea>
                                        <p class="reply-length" v-if="200-item.replyContent.length>=0">
                                            <span class="strong">{{item.replyContent.length}}</span>
                                            <span>/ 200</span>
                                        </p>
                                    </div>
                                    <p class="send-msg">
                                        <span class="cancel-btn"  @click="cancelComment(item)">取消</span>
                                        <span :class="['comment-btn', {'disabled': !item.replyContent.length}]"  @click="replyComment(item.cmt_id, false)">回复</span>
                                    </p>
                                </li>
                                <li class="reply-item" v-for="(reply, index) in item.replyList.items" :key="index">
                                    <div class="left-box">
                                        <img :src="reply.user_logo.indexOf('?') === 0 ? defaultAvatar : reply.user_logo" @click="goHomePage(reply)">
                                    </div>
                                    <div class="right-box">
                                        <div class="user-info">
                                            <span class="user-name" @click="goHomePage(reply)">{{reply.nick_name}}</span>
                                            <div class="time">
                                                {{reply.create_time}}
                                            </div>
                                        </div>
                                        <p class="comment" style="word-break: break-word;" v-html="filterXSS(reply.content)"></p>
                                        <div v-if="myComment.data.user_logo !== ''">
                                            <div v-if="item.is_self" class="delete" @click="secondaryPopup('myReply', reply.reply_id, false, item.cmt_id)">
                                                <i class="el-icon-delete"></i>
                                                删除
                                            </div>
                                            <div v-else-if="reply.user_id === user.uid" class="delete" @click="secondaryPopup('allReply', reply.reply_id, false, item.cmt_id)">
                                                <i class="el-icon-delete"></i>
                                                删除
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <!-- 加载更多评论回复 -->
                                <li class="load-item" v-if="item.replyList.page.curPage<item.replyList.page.totalPage">
                                    <span class="load-more"  @click="getReplyList(item.cmt_id, false, parseInt(item.replyList.page.curPage)+1)">加载更多</span>
                                </li>
                            </ul>
                        </transition>
                    </div>
                    </div>
                </li>
                </ul>
                <!-- 加载更多评论 -->
                <div class="load-more" v-if="pages.curPage<pages.totalPage">
                    <img v-if="isLoading" alt="loadding" src="../../images/common/loading_2_24x24.gif">
                    <span v-else>加载更多</span>
                </div>
            </div>
            <div class="bottom-box" v-if="commentList.length === 0 && myComment.data.content === undefined">
                <div class="search-null">
                <div class="icon-null">
                    <img src="../../images/common/search-null.png">
                </div>
                <p class="content">暂无评论，快来抢个沙发吧！</p>
                </div>
            </div>
            <div class="pop-wrapper" v-if="showPop">
                <div class="comment-box" v-if="showComment">
                    <p class="comment-title">撰写评论</p>
                    <div class="star-rating">
                        <el-rate
                            v-model="myComment.starNum"
                            void-icon-class="el-icon-star-on"
                            :colors="['#fe9c00', '#fe9c00', '#fe9c00']">
                        </el-rate>
                        <span class="star-num ">{{ myComment.starNum }}</span>分
                    </div>
                    <div class="textarea-wrapper">
                        <textarea class="msg" placeholder="请输入您评论内容，200字以内" name="msg" rows="8" cols="80" v-model="myComment.content" maxlength="200"></textarea>
                        <p class="reply-length" v-if="200-myComment.content.length>=0">
                            <span class="strong">{{myComment.content.length}}</span>
                            <span>/ 200</span>
                        </p>
                    </div>
                    <div class="submit-comment">
                        <span class="operat-btn primary" @click="sendComment">确定</span>
                        <span class="operat-btn" @click="onClosePop">取消</span>
                    </div>
                    <i class="el-icon-close" @click="onClosePop"></i>
                </div>
                <div class="pop-box" v-else>
                    <div class="pop-header clearfix">
                        <a href="javascript:;" class="fr" @click="onClosePop">
                        <img src="../../images/common/close.png" alt="">
                        </a>
                    </div>
                    <div class="pop-body">
                        确定删除<span v-if="deleteParams.type==='myComment'">反馈内容</span><span v-else>回复</span>？
                    </div>
                    <div class="pop-footer">
                        <a href="javascript:;" class="yes" @click="confirmDelete()">确定</a>
                        <a href="javascript:;" class="no" @click="showPop=false">取消</a>
                    </div>
                </div>
            </div>
        </template>
        <v-alert :options="options"></v-alert>
    </div>
</template>

<script type="text/javascript">
  import vAlert from "../alert.vue";
  import popup from "../popup.vue";
  import loading from '../loading.vue'
  import bus from '@/js/bus.js'

  export default {
    name: 'application-comment',
    filters: {
        formatHtml(html) {
            html = html.replace(/&amp;/ig, '&')
            html = html.replace(/&lt;/ig, '<')
            html = html.replace(/&gt;/ig, '>')
            html = html.replace(/&nbsp;/ig, ' ')
            html = html.replace(/&quot;/ig, '"')
            html = html.replace(/&#39;/ig, "'")
            return html
        }
    },
    props: {
        appDetail: {
            type: Object,
            default: () => ({})
        },
        user: {
            type: Object,
            default: () => ({})
        },
        badgeList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false,
            isLoading: false, // 加载评论列表中
            isThrottled: false, // 滚动节流 是否进入cd
            isPageOver: false, // 前端分页加载是否结束
            commentSortConditionList: [
                {
                    name: '最新评论',
                    type: 'comment'
                },
                {
                    name: '评分最高',
                    type: 'star'
                }
            ],
            defaultSortCondition: 'comment',
            showComment: false,
            allCommentPerson: 0,
            appSate: {
                star: 0,
                star_user: []
            },
            aid: 0,     // 作品id
            options: {   // 消息弹窗
                msgText: "",
                msgIsSuccess: true
            },
            defaultAvatar: require('@/images/personal_center/avatar_default.png'),
            myComment: {  // 我的评论
                isComment: false,    // 是否评论过
                isSubmit: false,     // 发表评论中
                content: "",         // 评论内容
                starNum: 5,
                replyShow: false,    // 是否展开回复列表(暂时用不到)
                replyContent: "",    //回复内容
                data: {
                    // user_logo: ""
                },            // 发表成功后返回值
                replyList: {         // 回复列表(暂时用不到)
                    items: [],
                    page: {
                        curPage: 1,
                        total: 1,
                        totalPage: 1
                    }
                }
            },
            commentList: [],  // 评论列表
            pages: {
                totalPage: 1,
                total: 0,
                curPage: 1
            },
            starHover:0,

            showPop: false,    // 删除评论时提示弹框

            deleteParams: {},  // 二次弹框参数
            ifLoginLoading: true,
            ifAdopted: false,
            orderByStar: undefined
        }
    },
    watch: {
        appDetail: {
            handler (val) {
                if (!val.id) return
                this.appSate = val || {}
                this.allCommentPerson = this.appSate.star_user.reduce((acc, cur) => {
                    acc = acc + cur
                    return acc
                })
            },
            immediate: true
        }
    },
    methods: {
        // 跳转到个人主页
        goHomePage (userInfo) {
            // 判断是否为自己或者他人
            const isMatch = this.userInfo.user_id === userInfo.user_id
            const path = isMatch ? '/s-mart/personal_center/' : `/s-mart/personal_center/user/${userInfo.user_id}`
            let routeData = this.$router.resolve({
                path
            })
            window.open(routeData.href, '_blank')
        },
        async initPage () {
            // 获取页面主要数据
            await axios.get(myUrl + "core/product/"+this.$route.params.aid+"/").then(res => {
                const resp = res.data
                if (resp.result) {
                    const { star_1, star_2, star_3, star_4, star_5 } = resp.data
                    const starUser = [star_5, star_4, star_3, star_2, star_1]
                    resp.data.star_user = starUser
                    this.appSate = resp.data
                    // 获取参与评论的人数
                    this.allCommentPerson = starUser.reduce((acc, cur) => {
                        acc = acc + cur
                        return acc
                    })
                } else {
                    console.warn(resp.message)
                    this.$router.push("/404")
                }
            })
        },
        login() { //请求登录
            axios.post(myUrl + "login/get_user_info/").then((res) => {
                res = res.data;
                if (!res.result) {
                    console.log(res.message);
                }else{
                    this.userInfo = res.data;
                }
            })
        },
        /*
            删除回复或评论
        */
        confirmDelete() {
            let deleteParams = this.deleteParams;
            switch(deleteParams.type){
                case "myComment":  // 删除我的评论
                    // this.deleteParams = {
                    //   type: type
                    // }
                    this.deleteComment(this.myComment.data.cmt_id);
                break;
                case "myReply":  // 删除我在我的评论下的某条回复
                    this.deleteReply(deleteParams.rid, deleteParams.isMe, deleteParams.cid);
                    // this.deleteParams = {
                    //   type: type,
                    //   rid: rid,
                    //   isMe: isMe
                    // }
                break;
                case "allReply":  // 删除我在所有评论下的某条回复
                    this.deleteReply(deleteParams.rid, deleteParams.isMe, deleteParams.cid);
                    // this.deleteParams = {
                    //   type: type,
                    //   rid: rid,
                    //   isMe: isMe,
                    //   cid: cid
                    // }
                break;
            }
        },
        /*
            确定删除回复或评论?
        */
        secondaryPopup(type, rid, isMe, cid) {
            this.showPop = true;
            switch(type){
                case "myComment":  // 删除我的评论
                    this.deleteParams = {
                    type: type
                    }
                    // this.deleteComment(myComment.data.cmt_id);
                break;
                case "myReply":  // 删除我在我的评论下的某条回复
                    // this.deleteReply(rid, isMe, cid);
                    this.deleteParams = {
                    type: type,
                    rid: rid,
                    isMe: isMe,
                    cid: cid
                    }
                break;
                case "allReply":  // 删除我在所有评论下的某条回复
                    // this.deleteReply(rid, isMe, cid);
                    this.deleteParams = {
                    type: type,
                    rid: rid,
                    isMe: isMe,
                    cid: cid
                    }
                break;
            }
        },
        /*
            @他
            isMe 我的评论 ? true : false
            nick_name   昵称
            reply    isMe为true时 undefined
        */
        addContent(isMe, nick_name, reply) {
            if (isMe) {
                if (this.myComment.replyContent.length + nick_name.length + 2 > 200) {
                    this.options = {
                        msgIsSuccess: false,
                        msgText: "内容长度超出限制"
                    }
                    return ;
                }
                this.myComment.replyContent += "@" + nick_name + " ";
            }else {
                if (reply.replyContent.length + nick_name.length + 2 > 200) {
                    this.options = {
                        msgIsSuccess: false,
                        msgText: "内容长度超出限制"
                    }
                    return ;
                }
                reply.replyContent += "@" + nick_name + " ";
            }
        },
        leaveStar(num) {
            this.starHover = 0;
        },
        hoverStar(num) {
            this.starHover = num;
            this.myComment.starNum = 0;
        },
        setStar(num) {  //评星
            this.myComment.starNum = num;
        },
        // 根据最新/评分最高来排序
        handleCommentSort (type) {
            this.defaultSortCondition = type
            this.orderByStar = type === 'star' ? true : undefined
            this.getCommentList(1, true)
            this.visible = false
        },
        getCommentList (curPage, sort = false) {  // 获取评论列表
            this.isLoading = true
            this.myComment.data = {
                user_logo: ''
            }
            axios.post(myUrl + "sns/comment/" + this.$route.params.aid + "/", qs.stringify({
                page: curPage,
                order_by_star: this.orderByStar
            })).then(res => {
                const resp = res.data
                if (resp.result) {
                    const { items, me, page } = resp.data
                    if (me.cmt_id === undefined) { // 用户未登录
                        this.myComment.data = {
                            user_logo: ''
                        }
                    } else if (me.cmt_id === -1){  // 用户未评论
                        this.myComment.isComment = false
                        this.myComment.data = me
                    } else {  // 用户已评论
                        this.myComment.isComment = true
                        this.myComment.data = me
                    }
                    
                    items.forEach(item => {
                        item.replyShow = false
                        item.replyContent = ''
                        item.replyList = {
                            items: [],
                            page: {}
                        }
                    })
                    
                    if (sort) {
                        this.commentList = items
                    } else {
                        this.commentList = this.commentList.concat(items)
                    }
                    this.pages = page
                    this.ifLoginLoading = false
                    this.isPageOver = parseInt(page.curPage)  === page.totalPage
                } else {
                    console.log(resp.message)
                    this.ifLoginLoading = false

                }
                this.isLoading = false
            })
        },
        /*
            展开回复列表
            cid: 评论id
        */
        unFoldReplyList(cid, isMe, curPage) {
            if (!this.isLogin) {
                this.login()
                return
            }
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup');
                return;
            }
            let speComment = isMe ? this.myComment : this.getSpeComment(cid);
            if (speComment.replyShow) {
                speComment.replyList = {
                    items: [],
                    page: {
                    curPage: 1,
                    totalPage: 1,
                    total: 1,
                    }
                }
            } else {
                this.getReplyList(cid, isMe, curPage);
            }
            speComment.replyShow = !speComment.replyShow;
        },
        /*
            获取回复列表
            cid: 评论id
            isMe: 我的评论 ? true : false,
            curPage: 页码
        */
        getReplyList(cid, isMe, curPage) {
            axios.post(myUrl + "sns/reply/" + cid + "/", qs.stringify({
                page: curPage
            })).then((res) => {
                res = res.data;
                if (res.result) {
                    let speComment = isMe ? this.myComment : this.getSpeComment(cid);
                    if (curPage===1) {
                        speComment.replyList.items = res.data.items;
                    }else {
                        speComment.replyList.items = speComment.replyList.items.concat(res.data.items);
                    }
                    speComment.replyList.page = res.data.page;
                    // if (isMe) {
                    //   if (curPage===1) {  // 第一页时不更新视图
                    //     this.myComment.replyList.items = res.data.items;
                    //   }else {
                    //     this.myComment.replyList.items = this.myComment.replyList.items.concat(res.data.items);
                    //   }
                    //   this.myComment.replyList.page = res.data.page;
                    // }else {
                    //   let speComment = this.getSpeComment(cid);
                    //
                    //   speComment.replyList.items = speComment.replyList.items.concat(res.data.items);
                    //   speComment.replyList.page = res.data.page;
                    // }
                } else {
                    console.log(res.message);
                }
            })
        },
        /*
            获取指定的评论
            cid: 评论id
        */
        getSpeComment(cid) {
            for (var i = 0; i < this.commentList.length; i++) {
                if (this.commentList[i].cmt_id === cid) {
                    return this.commentList[i];
                }
            }
        },
        /*
            发表评论
        */
        sendComment() {
            if (this.myComment.content === "") {
                this.options = {
                    msgText: "请输入评论内容",
                    msgIsSuccess: false
                }
                return ;
            }
            if (this.myComment.content.trim() === "") {
                this.options = {
                    msgText: "输入内容不能为空",
                    msgIsSuccess: false
                }
                return ;
            }
            if (this.myComment.content.length > 200) {
                this.options = {
                    msgIsSuccess: false,
                    msgText: "内容长度超出限制"
                }
                return ;
            }
            this.myComment.isSubmit = true;
            axios.post(myUrl + "sns/comment/leave/" + this.aid + "/", qs.stringify({
                star: this.myComment.starNum,
                content: this.myComment.content
            })).then((res) => {
                this.showPop = false
                this.showComment = false
                res = res.data;
                this.myComment.isSubmit = false;
                if (res.result) {
                    this.options = {
                        msgText: "意见反馈成功",
                        msgIsSuccess: true
                    }
                    // 重新获取评论列表
                    this.myComment.isComment = true;
                    this.defaultSortCondition = 'comment'
                    this.orderByStar = undefined
                    this.getCommentList(1, true)
                    // 获取打分数据
                    this.initPage()
                } else {
                    this.options = {
                        msgText: "发表评论失败",
                        msgIsSuccess: false
                    }
                }
            }).catch((e) => {
                console.warn(e);
                this.myComment.isSubmit = false;
            })
        },
        /*
            删除评论
        */
        deleteComment(cid) {
            this.showPop = false;
            axios.post(myUrl + "sns/comment/delete/" + cid + "/").then((res) => {
                res = res.data;
                if (res.result) {
                    this.options = {
                        msgText: "删除反馈内容成功",
                        msgIsSuccess: true
                    }
                    const index = this.commentList.findIndex(item => item.cmt_id === cid)
                    if (index > -1) {
                        this.commentList.splice(index, 1)
                    }
                    this.myComment.isComment = false;
                    this.myComment.content = "";
                }else {
                    this.options = {
                        msgText: "删除反馈内容失败，请稍后重试",
                        msgIsSuccess: false
                    }
                    console.log(res.message)
                }
            })
        },
        /*
            赞同评论
            cid: 评论id
        */
        agreeComment(cid, isMe) {
            if (!this.isLogin) {
                this.login()
                return
            }
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup');
                return;
            }
            axios.post(myUrl + "sns/comment/ding/" + cid + "/").then((res) => {
                res = res.data;
                if (res.result) {
                    this.options = {
                        msgText: "点赞成功",
                        msgIsSuccess: true
                    }
                    let speComment = isMe ? this.myComment.data : this.getSpeComment(cid);
                    speComment.agree_cnt++;
                    speComment.is_favor = true;
                }else {
                    this.options = {
                        msgText: "点赞失败，请稍后重试",
                        msgIsSuccess: false
                    }
                }
            })
        },
        // 取消回复
        cancelComment (content) {
            content.replyContent = ''
            content.replyShow = false
        },
        /*
            回复评论
            cid: 评论id
        */
        replyComment(cid, isMe) {
            let data = {};
            let content = isMe ? this.myComment.replyContent : this.getSpeComment(cid).replyContent;
            data = {
                at_list: [],
                content: content
            }
            // if (isMe) {
            //   data = {
            //     at_list: [],
            //     content: this.myComment.replyContent
            //   }
            // }else {
            //   data = {
            //     at_list: [],
            //     content: this.getSpeComment(cid).replyContent
            //   }
            // }
            if (data.content == "") {
                return ;
            }
            if (data.content.trim() === "") {
                this.options = {
                    msgText: "输入内容不能为空",
                    msgIsSuccess: false
                }
                return ;
            }
            if (data.content.lenght > 200) {
                this.options = {
                    msgIsSuccess: false,
                    msgText: "内容长度超出限制"
                }
                return ;
            }
            axios.post(myUrl + "sns/comment/reply/" + cid + "/", qs.stringify(data)).then((res) => {
                res = res.data;
                if (res.result) {
                    this.options = {
                        msgText: "回复成功",
                        msgIsSuccess: true
                    }
                    let speComment = this.getSpeComment(cid);
                    this.getReplyList(cid, isMe, 1);
                    if (isMe) {
                        this.myComment.data.reply_cnt++;
                        this.myComment.replyContent = "";
                    }else{
                        speComment.reply_cnt++;
                        speComment.replyContent = "";
                    }
                }else {
                    this.options = {
                        msgText: "回复失败，请稍后重试",
                        msgIsSuccess: false
                    }
                    console.log(res.message);
                }
            })
        },
        /*
            删除回复
            rid: 回复id
        */
        deleteReply(rid, isMe, cid) {
            this.showPop = false;
            axios.post(myUrl + "sns/reply/delete/" + rid + "/").then((res) => {
                res = res.data;
                if (res.result) {
                    this.options = {
                        msgText: "删除回复成功",
                        msgIsSuccess: true
                    }
                    let speComment = isMe ? this.myComment : this.getSpeComment(cid)
                    for (var i = 0; i < speComment.replyList.items.length; i++) {
                        if (speComment.replyList.items[i].reply_id == rid){
                            speComment.replyList.items.splice(i, 1);
                            break;
                        }
                    }
                    if (isMe) {
                        this.myComment.data.reply_cnt--;
                    }else {
                        speComment.reply_cnt--;
                    }
                } else {
                    this.options = {
                        msgText: "删除回复失败，请稍后重试",
                        msgIsSuccess: false
                    }
                }
            })
        },
        /*
            关闭弹框
        */
        onClosePop () {
            this.showPop = false
            this.showComment = false
        },
        /*
            新增评论
        */
        onWriteComment () {
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup');
                return;
            }
            this.showComment = true
            this.showPop = true
        },
        handleScroll () {
            this.isShowBackTop = window.scrollY > 0
            if (!this.isPageOver && !this.isThrottled && !this.isLoading) {
                this.isThrottled = true
                setTimeout(() => {
                    this.isThrottled = false
                    const scrollHeight = document.documentElement.scrollHeight
                    const innerHeight = window.innerHeight
                    const scrollY = window.scrollY
                    const height = 120 + 320 // 320 footer的高度
                    if (scrollHeight - innerHeight - scrollY < height) {
                        const page = parseInt(this.pages.curPage) + 1
                        this.getCommentList(page)
                    }
                }, 200)
            }
        }
    },
    computed: {
        isLogin () {
            return this.$store.state.isLogin;
        },
        userInfo () {
            return this.$store.state.userInfo
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
        this.$nextTick(() => {
            this.aid = this.$route.params.aid
            this.getCommentList(1)  // 获取评论列表 默认加载第一页
        })
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    components: {
        "v-alert": vAlert,
        popup,
        'loading': loading
    }
  }
</script>
<style lang="scss">
    .sort-popover {
        min-width: 97px;
        padding: 5px 0;
        .sort-item {
            width: 100%;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 12px;
            color: #63656e;
            cursor: pointer;
            &.active,
            &:hover {
                color: #3a84ff;
                background: #eaf3ff;
            }
        }
    }
</style>

<style media="screen" lang="scss" scoped>
    pre{
        word-wrap: break-word;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
    }
  .show-enter-active,.show-leave {
        opacity: 1;
        transition: all .3s;
  }
  .show-leave-active,.show-enter {
        opacity: 0;
        transition: all .3s;
  }
  .comment-content-wrapper{
        .loading {
            margin: 100px 0 80px;
        }
        .top-box {
            display: flex;
            width: 100%;
            height: 124px;
            background: #fafbfd;
            border-radius: 2px;
            padding: 16px 30px;
            margin-bottom: 16px;
            .left-content {
                margin-right: 85px;
                p {
                    color: #313238;
                    font-weight: 700;
                    font-size: 14px;
                }
                .score {
                    font-size: 40px;
                }
                .no-score {
                    font-size: 16px;
                    margin: 17px 0 18px;
                }
                .summary {
                    color: #63656e;
                    font-size: 12px;
                }
            }
            .center-content {
                .content-item {
                    height: 17px;
                    margin-bottom: 1px;
                    display: flex;
                    align-items: center;
                    .star-area {
                        width: 66px;
                        text-align: right;
                        margin-right: 14px;
                        .el-icon-star-on {
                            font-size: 12px;
                            transform: scale(.8);
                            color: #c4c6cc;
                        }
                    }
                    .progress-area {
                        position: relative;
                        width: 370px;
                        height: 8px;
                        opacity: 1;
                        background: #f0f1f5;
                        .progress {
                            height: 8px;
                            width: 0px;
                            position: absolute;
                            left: 0;
                            top: 0;
                            background: #c4c6cc;
                            border-radius: 0;
                        }
                    }
                    .user-area {
                        font-size: 12px;
                        text-align: left;
                        color: #979ba5;
                        margin-left: 13px;
                    }
                }
            }
            .right-content {
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-left: 168px;
                .comment {
                    img {
                        height: 26px;
                        width: 26px;
                    }
                }
                .smart-button {
                    width: 130px;
                    height: 32px;
                    background: #3a84ff;
                    color: #fff;
                    border-radius: 2px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    &:hover {
                        background: #699df4;
                    }
                }
                .login {
                    cursor: pointer;
                    color: #3a84ff;
                    margin-right: 2px;
                }
                .login-btn {
                    margin-top: 15px;
                }
            }
        }
        .comment-header {
            height: 42px;
            width: 100%;
            background: #fafbfd;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 11px 0 16px;
            font-weight: 700;
            color: #313238;
            font-size: 14px;
            margin-bottom: 18px;
            .comment-num {
                margin: 0 5px;
            }
            .new-comment {
                font-size: 12px;
                color: #3a84ff;
                font-weight: normal;
                display: flex;
                align-items: center;
                cursor: pointer;
                img {
                    font-size: 14px;
                    margin-left: 3px;
                    transform: rotate(180deg);
                    height: 20px;
                    width: 20px;
                    color: #3a84ff;
                }
            }

        }
        .bottom-box{
            padding: 0 80px 0 20px;
            .msg-list{
                .msg-item{
                    margin-bottom: 12px;
                    &:first-child{
                        border-top: 0;
                    }
                }
                .msg-content{
                    display: flex;
                    .left-box{
                        margin-right: 11px;
                        img {
                            height: 46px;
                            width: 46px;
                            border-radius: 50%;
                            cursor: pointer;
                        }
                    }
                    .center-box {
                        flex: 1;
                        font-size: 12px;
                        padding-bottom: 12px;
                        border-bottom: 1px solid #f0f1f5;
                        .user-info {
                            display: flex;
                            align-items: center;
                            .nick_name {
                                font-size: 14px;
                                color: #313238;
                                line-height: 19px;
                                cursor: pointer;
                                margin-right: 5px;
                            }
                            img {
                                height: 16px;
                                width: 16px;
                            }
                            .author {
                                width: 40px;
                                height: 18px;
                                text-align: center;
                                line-height: 18px;
                                color: #3a84ff;
                                font-size: 12px;
                                transform: scale(.8);
                                background: #edf4ff;
                                border-radius: 2px;
                                position: relative;
                                top: 1px;
                            }
                        }
                        
                        .star-rate {
                            margin: 5px 0 15px;
                        }
                        .comment {
                            color: #63656e;
                            line-height: 22px;
                            margin-bottom: 14px;
                        }
                        .center-footer {
                            display: flex;
                            align-self: center;
                            justify-content: space-between;
                            .interact{
                                display: flex;
                                align-self: center;
                                color: #63656e;
                                div{
                                    margin-right: 30px;
                                    cursor: pointer;
                                    .number{
                                        font-family: Arial, Helvetica, sans-serif;
                                    }
                                    img {
                                        height: 12px;
                                        width: 11px;
                                    }
                                    .el-icon-delete {
                                        font-size: 12px;
                                    }
                                }
                                
                                .agree{
                                    display: flex;
                                    align-items: center;
                                    .like-img {
                                        height: 14px;
                                        width: 14px;
                                        margin-right: 3px;
                                        background: url(../../images/application_detail/like.png) no-repeat;
                                        background-size: 100% 100%;
                                    }
                                    &:hover,
                                    &.active {
                                        color: #3a84ff;
                                        .like-img {
                                        background: url(../../images/application_detail/like2.png) no-repeat;
                                        background-size: 100% 100%;
                                        }
                                    }
                                    .number {
                                        margin-left: 5px;
                                    }
                                }
                                .reply {
                                    display: flex;
                                    align-items: center;
                                    .reply-img {
                                        height: 14px;
                                        width: 14px;
                                        margin-right: 3px;
                                        background: url(../../images/application_detail/reply.png) no-repeat;
                                        background-size: 100% 100%;
                                    }
                                    .number {
                                        margin-left: 5px;
                                    }
                                }
                                .delete:hover {
                                    color: #3a84ff;
                                }
                            }
                            .time {
                                color: #979ba5;
                            }
                        }
                        &.show-replay {
                            border-bottom: none;
                        }
                    }
                }
                .reply-list{
                    padding: 20px 20px 0;
                    background: #fafbfd;
                    margin: 9px 0 22px;
                    .reply-item{
                        margin-top: 18px;
                        display: flex;
                        .left-box{
                            margin-right: 11px;
                            img {
                                height: 36px;
                                width: 36px;
                                border-radius: 50%;
                                cursor: pointer;
                            }
                        }
                        .right-box{
                            flex: 1;
                            border-bottom: 1px solid #f0f1f5;
                            padding-bottom: 15px;
                            font-size: 12px;
                            .user-info{
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                margin-bottom: 15px;
                                .user-name{
                                    font-size: 14px;
                                    color: #313238;
                                    cursor: pointer;
                                }
                                .time{
                                    line-height: 16px;
                                    color: #979ba5;
                                }
                            }
                            .comment{
                                background: none !important;
                                line-height: 22px !important;
                                strong{
                                    color: #32343c;
                                    font-weight: normal;
                                }
                            }
                            .at{
                                color: #b9b9bd;
                                cursor: pointer;
                                display: inline-block;
                                user-select: none;
                            }
                            .delete{
                                color: #b9b9bd;
                                cursor: pointer;
                                display: inline-block;
                                &:hover{
                                    color: #3a84ff;
                                }
                            }
                        }
                    }
                    .myreply{
                        // display: flex;
                        padding-bottom: 20px;
                        .textarea-wrapper {
                            position: relative;
                            height: 88px;
                            border: 1px solid #e5e5e5;
                            background: #fff;
                            .msg{
                                width: 880px;
                                height: 70px;
                                resize: none;
                                padding: 10px;
                                border: none;
                                outline: none;
                                line-height: 22px;
                            }
                            .reply-length {
                                position: absolute;
                                bottom: -1px;
                                right: 7px;
                                font-size: 12px;
                                transform: scale(.8);
                                color: #979ba5;
                                .strong {
                                    color: #63656e;
                                }
                            }
                        }
                        .send-msg{
                            margin-top: 14px;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            .cancel-btn, .comment-btn {
                                height: 32px;
                                line-height: 32px;
                                text-align: center;
                                border-radius: 2px;
                                cursor: pointer;
                            }
                            .cancel-btn {
                                width: 68px;
                                border: 1px solid #c4c6cc;
                                border-radius: 3px;
                                color: #63656e;
                                margin-right: 8px;
                            }
                            .comment-btn {
                                width: 86px;
                                color: #fff;
                                background: #3a84ff;
                                &.disabled{
                                    background: #dcdee5;
                                    cursor: not-allowed;
                                }
                            }
                        }
                    }
                    .load-item {
                        margin-top: 50px;
                        width: 100%;
                        text-align: center;
                        color: #979ba5;
                        font-size: 12px;
                        padding-bottom: 10px;
                        .load-more {
                            cursor: pointer;
                        }
                    }
                    li:nth-of-type(2) {
                        margin-top: 0;
                    }
                }
            }
            .load-more {
                margin-top: 84px;
                width: 100%;
                text-align: center;
                color: #979ba5;
                font-size: 12px;
                cursor: pointer;
            }
            .search-null{
                padding-top: 139px;
                padding-bottom: 175px;
                .icon-null{
                    text-align: center;
                }
                .content{
                    margin-top: 22px;
                    font-size: 14px;
                    color: #63656e;
                    text-align: center;
                }
            }
        }
        .pop-wrapper{
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(0,0,0,.3);
            z-index: 1111;
            .comment-box {
                width: 650px;
                height: 392px;
                position: absolute;
                top: 45%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: #ffffff;
                border-radius: 2px;
                box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.20); 
                padding: 19px 24px 9px;
                p {
                    justify-content: space-between;
                    font-size: 20px;
                    color: #313238;
                    margin-bottom: 26px;
                }
                .star-rating {
                    margin-bottom: 20px;
                    display: flex;
                    align-items: center;
                    .star-num {
                        margin-left: 10px;
                    }
                }
                .textarea-wrapper {
                    position: relative;
                    height: 205px;
                    border: 1px solid #e5e5e5;
                    background: #fff;
                    .msg{
                        width: 600px;
                        height: 190px;
                        resize: none;
                        padding: 10px;
                        border: none;
                        outline: none;
                        line-height: 22px;
                        font-size: 12px;
                    }
                    .reply-length {
                        position: absolute;
                        bottom: -1px;
                        right: 7px;
                        font-size: 12px;
                        transform: scale(.8);
                        color: #979ba5;
                        margin: 0;
                        .strong {
                            color: #63656e;
                        }
                    }
                }
                .submit-comment {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    padding-right: 24px;
                    background: #fafbfd;
                    border-top: 1px solid #dcdee5;
                    .operat-btn {
                        width: 76px;
                        height: 32px;
                        text-align: center;
                        line-height: 32px;
                        font-size: 14px;
                        color: #63656e;
                        background: #fff;
                        cursor: pointer;
                        border-radius: 2px;
                        border: 1px solid #c4c6cc;
                    }
                    .primary {
                        background: #3a84ff;
                        color: #fff;
                        margin-right: 10px;
                        border-color:#3a84ff;
                    }
                }
                .el-icon-close {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    font-size: 24px;
                    cursor: pointer;
                    color: #979ba5;
                    &:hover {
                        color: #3a84ff;
                    }
                }
            }
            .pop-box{
                width: 400px;
                position: absolute;
                top: 40%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: #fff;
                padding: 20px;
                border-radius: 3px;
                .pop-header{
                    margin-bottom: 10px;
                }
                .pop-body{
                    text-align: center;
                    font-size: 22px;
                    color: #333;
                    width: 100%;
                }
                .pop-footer{
                    padding: 20px 45px 20px;
                    text-align: center;
                    font-size: 0;
                    .yes,.no{
                        font-size: 16px;
                        height: 36px;
                        line-height: 36px;
                        border-radius: 3px;
                        display: inline-block;
                        width: 110px;
                    }
                    .yes{
                        color: #fff;
                        background: #57a3f1;
                        margin-right: 20px;
                    }
                    .no{
                        color: #666;
                        border: 1px solid #e5e5e5;
                    }
                }
            }
        }
        .top-box-unlogged{
            position: absolute;
            left: 0;
            top: 0;
            background: #ffffff;
            width: 100%;
            height: 100%;
            text-align: center;
            .top-box-unloggedDiv {
                display: table-cell;
                vertical-align: middle;
                width: 778px;
                height: 170px;
            }
            .bk-radius {
                border-radius: 18px;
                margin: 0 0 20px 0;
            }
        }
    }
    .icon-adopted{
        position: absolute;
        display: inline-block;
        width: 82px;
        height: 75px;
        right: 0;
        top: 0;
        opacity: 0.3;
        background: url(../../images/personal_center/adopted.png) no-repeat;
    }
</style>


// WEBPACK FOOTER //
// comment.vue?7ce0b74c